import { useAnalytics } from '../amplitude';
import { AMPLITUDE_EVENTS,REACT_APP_AHA_IDEA_WIDGET } from '../../../constants';
import { createIconWithPath} from 'cdk-radial';
import { TextButton } from '../../../components/Buttons/TextButton';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { useTheme } from "../../theme/useTheme";

const AhaWidget = () => {

  const { trackEvent } = useAnalytics();
  const {t} = useTranslation();
  const ahaIdeasFlag = useFeatureFlag('UNIFY_UI_AHA');
  const { darkMode } = useTheme();

  const handleAhaWidget = () => {
      trackEvent(AMPLITUDE_EVENTS.HEADER_ITEM_SELECTED,{'Item': 'Submit An Idea'})
      const aha = window.aha;
      aha && aha('open', REACT_APP_AHA_IDEA_WIDGET);
  };

  const BulbIcon = createIconWithPath([{
    d: "M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z",
    fillRule: "evenodd",
    fill: darkMode ? 'white' : 'black'
  }]);


  return  <> 
    {
    ahaIdeasFlag && (
      <TextButton
              icon={<BulbIcon />} 
              text={t('header.submitIdea')}
              onClick={handleAhaWidget}
              darkMode={darkMode}
              style={{ fontSize: "14px", fontWeight: "500", fontFamily:"Roboto,Montserrat,sans-serif"}} id={'aha-widget'}/>
    )
  } 
  </>;

}

export default AhaWidget; 